module.exports = __webpack_public_path__ + "img/selogo.b6bcf6c3.png";